import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { DailyLogService } from '../../../services/daily-log/daily-log.service';
import { NavMainMenuPage } from '../../nav/nav-menus/nav-main-menu/nav-main-menu';
import { DateService } from '../../../services/date/date.service';
import { SetupService } from '../../../services/setup/setup.service';
import { OperationService } from '../../../services/operations/operation/operation.service';
import { DailyLogPage } from '../../daily-log/daily-log/daily-log';
import {
  LocationChangeEditor,
  LocationOption,
  LocationSelectOptions,
  SetupChangeLogRecord,
  SetupChangeType,
  SetupMetadata,
  UpdatedSetupSummary
} from '../../../models/setup/setup.models';
import { OperationSaveService } from '../../../services/operations/operation-save/operation-save.service';
import { TransitingSaveService } from '../../../services/operations/transiting-save/transiting-save.service';
import { NavHelperService } from '../../../services/nav/nav-helper.service';
import { DailyLogModalPage } from '../../daily-log/daily-log-modal/daily-log-modal';
import {
  DailyLogOperationInstance,
  DailyLogType,
  DailyOperationLogRecord,
  DailyOperationLogRecordHelper,
  LogComment,
  StepInstance,
  VoyageLogCreateSelectOptions,
  VoyageLogEndSelectOptions
} from '../../../models/projects/operation.models';
import { RecordOperationLinkService } from '../../../services/record-operation-link/record-operation-link.service';
import { AppDataSyncService } from '../../../services/app-data-sync/app-data-sync.service';
import { LocalOperationSaveService } from '../../../services/local/operation/local-operation-save.service';
import { AppData, AppDataSummary, OperationInstanceSaveRequest } from '../../../models/app-data/app-data';
import { JackingActivityService } from '../../../services/jacking-activity/jacking-activity.service';
import { FieldPositioningService } from '../../../services/field-positioning/field-positioning.service';
import { VesselService } from '../../../services/vessel/vessel.service';
import { OnSiteMovementService } from '../../../services/on-site-movement/on-site-movement.service';
import { VoyageLogSummary } from '../../../models/voyage-log/voyagelog.models';
import { ApiOption } from '../../../_foundation/models/base.models';
import { VoyageLogService } from '../../../services/voyage-log/voyage-log.service';
import { ErrorType, ValidationResult } from '../../../models/projects/validation.models';
import { OperationTimeService } from '../../../services/operations/operation-time/operation-time.service';
import { cloneDeep } from 'lodash';
import { PtLuxonDate } from '../../../models/projects/date.models';
import { DailyLogEntriesService } from '../../../services/daily-log/daily-log-entries/daily-log-entries.service';
import { TimeZoneService } from '../../../services/time-zone/time-zone.service';
import { AffectedTransitHelper, TransitSummary } from '../../../models/transit/transit.models';
import { TransitService } from '../../../services/transit/transit.service';
import { AppConfig } from '../../../app/app.config';
import { DateTime } from 'luxon';
import { SupportContextKey } from '../../../models/support/support.models';
import { SupportContextService } from '../../../services/support/support-context.service';

@IonicPage()
@Component({
  selector: 'page-operation-details-edit-location-select',
  templateUrl: 'operation-details-edit-location-select.html',
})
export class OperationDetailsEditLocationSelectPage {

  config = AppConfig.settings;
  loading: boolean = true;
  voyageLoading: boolean;
  saved: boolean = false;
  dailyLogDate: PtLuxonDate;
  instance: DailyLogOperationInstance;
  stepInstances: StepInstance[] = [];
  currentUpdatedSetupSummary: UpdatedSetupSummary;
  setupMetadata: SetupMetadata;
  previousLocation: string;
  currentLocationLastChanged: string;
  previousSetupId: number;
  previousLocationStart: string;
  previousLocationEnd: string;
  hidePreviousLocationTo: boolean;
  locationOptions: LocationOption[] = [];
  selectedLocation: LocationOption;
  locationSelectOptions: any = new LocationSelectOptions().options;
  newLocationId: number;
  originalComments: LogComment[];
  locationChangeValidationResult: ValidationResult = new ValidationResult();
  public mask: Array<string | RegExp> = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];
  endOfDay: PtLuxonDate;

  startLinkedVoyageLog: VoyageLogSummary;
  endLinkedVoyageLog: VoyageLogSummary;
  voyageLogForOperationTime: VoyageLogSummary;
  precedingVoyageLog: VoyageLogSummary;
  voyageLogValidationResult: ValidationResult = new ValidationResult();
  voyageLogOptions: ApiOption<number>[] = [];
  voyageLogCreateSelectOptions: any = new VoyageLogCreateSelectOptions().options;
  voyageLogEndSelectOptions: any = new VoyageLogEndSelectOptions().options;
  voyageLogCreateId: number;
  showVoyageCreationOption: boolean;
  showVoyageEndOption: boolean;
  voyageLogEndId: number;
  voyageDistance: number;

  transitRecords: SetupChangeLogRecord[];
  transitRecordLatestLocalId: number;
  setupChangeLogRecordsToDelete: SetupChangeLogRecord[];
  jackingDataUpdated: boolean;
  latestTransit: SetupChangeLogRecord;

  affectedTransitHelper: AffectedTransitHelper;
  transitPreview: TransitSummary;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public setupService: SetupService,
              public dateService: DateService,
              public operationService: OperationService,
              public operationSaveService: OperationSaveService,
              private operationTimeService: OperationTimeService,
              public dailyLogService: DailyLogService,
              public transitingSaveService: TransitingSaveService,
              public recordOperationLinkService: RecordOperationLinkService,
              public navHelperService: NavHelperService,
              public modalController: ModalController,
              private appDataSyncService: AppDataSyncService,
              private fieldPositioningService: FieldPositioningService,
              private localOperationSaveService: LocalOperationSaveService,
              private toastCtrl: ToastController,
              private jackingActivitySerivce: JackingActivityService,
              private vesselService: VesselService,
              private onSiteMovementService: OnSiteMovementService,
              private voyageLogService: VoyageLogService,
              private dailyLogEntryService: DailyLogEntriesService,
              private timeZoneService: TimeZoneService,
              private transitService: TransitService,
              private supportContextService: SupportContextService,
  ) {
    this.instance = navParams.get('instance');
    this.stepInstances = navParams.get('stepInstances');
    this.originalComments = navParams.get('originalComments');
    this.dailyLogDate = navParams.get('dailyLogDate');
  }

  openDailyLogModal() {
    const dailyLogModal = this.modalController.create(DailyLogModalPage);
    dailyLogModal.present();
  }

  async ionViewDidLoad() {
    this.setSupportContext();

    this.jackingDataUpdated = false;
    this.appDataSyncService.refreshJackingDataForDate(this.dailyLogDate).then(() => {
      this.jackingDataUpdated = true;
    });

    this.affectedTransitHelper = await this.transitService.getAffectedTransits(this.instance.startTime, this.instance.endTime, this.instance.id);

    this.getCurrentLocation();
    this.endOfDay = await this.dateService.getEndOfDayLocally(this.dailyLogDate.dateTime);
    this.setupChangeLogRecordsToDelete = [];
    let transitEndOrInstanceEnd = this.instance.endTime;

    if (this.affectedTransitHelper.transitAfterOperation) {
      transitEndOrInstanceEnd = this.affectedTransitHelper.transitAfterOperation.endDate;
    }
    
    // if we are currently editing the first operation of the transit, search for transits between times inclusively
    // fixes issue where editing a concurrent operation that starts at the transit start time, would 'steal' the
    // 'Transiting To: x' daily log record from the actual transit start operation
    this.transitRecords = await this.setupService
      .getTransitsBetweenTimes(this.instance.startTime, transitEndOrInstanceEnd && transitEndOrInstanceEnd.dateTime
        ? transitEndOrInstanceEnd
        : this.endOfDay,
        this.affectedTransitHelper?.linkedTransit?.operationInstances[0] && this.affectedTransitHelper?.linkedTransit?.operationInstances[0].id == this.instance.id);
    this.transitRecordLatestLocalId = await this.setupService.getNewSetupChangeRecordLocalId();

    if (this.instance.projectSpecificOperation.operationSummary.subClassificationName === 'Harbour Manoeuvres') {
      this.voyageLoading = true;
      const operationTime = this.instance.startTime.dateTime;

      const voyageData = await Promise.all([
        this.voyageLogService.getVoyageLogForStartOperationId(this.instance.id),
        this.voyageLogService.getVoyageLogForEndOperationId(this.instance.id),
        this.voyageLogService.getVoyageLogForTime(operationTime),
        this.voyageLogService.getLatestVoyageLogBeforeTime(operationTime)
      ]);

      this.startLinkedVoyageLog = voyageData[0];
      this.endLinkedVoyageLog = voyageData[1];
      this.voyageLogForOperationTime = voyageData[2];
      this.precedingVoyageLog = voyageData[3];

      if (this.startLinkedVoyageLog) {
        this.voyageLogCreateId = 1; // needs to be separate from below if so Yes doesn't show when there is no linked log
      }

      if (this.endLinkedVoyageLog) {
        this.voyageLogEndId = 1;
        this.voyageDistance = this.endLinkedVoyageLog.distance;
      }

      if (this.startLinkedVoyageLog || (!this.endLinkedVoyageLog && !this.voyageLogForOperationTime)) {
        this.showVoyageCreationOption = true;
        this.voyageLogOptions = [{id: 1, name: 'Yes'}, {id: 2, name: 'No'}];
      } else if (this.endLinkedVoyageLog || this.voyageLogForOperationTime) {
        this.showVoyageEndOption = true;
        this.voyageLogOptions = [{id: 1, name: 'Yes'}, {id: 2, name: 'No'}];
      }

      this.voyageLoading = false;
    }
  }

  async getCurrentLocation() {
    const vesselEditor = await this.vesselService.getEditor();

    this.setupService
      .getSetupMetadata(vesselEditor.id, this.dailyLogDate.dateTime)
      .then(metadata => {
        this.setupMetadata = metadata;

        let latestOperationTime = this.operationService.getLatestTimeInOperationInstance(this.instance, this.endOfDay);
        if (latestOperationTime.dateTime.toMillis() < this.dailyLogDate.dateTime.toMillis()) {
          latestOperationTime = cloneDeep(this.dailyLogDate);
        }

        this.setupService.getSetupSummary(latestOperationTime, false)
          .then(async setupSummary => {
            this.currentUpdatedSetupSummary = !setupSummary ? new UpdatedSetupSummary() : setupSummary;
            // if currentSummary.transiting exists, then use that for the lastChanged date, otherwise use the location change
            this.currentLocationLastChanged = await this.dateService
              .setFullTimeString(this.currentUpdatedSetupSummary.transitingTimeChanged && this.currentUpdatedSetupSummary.transitingTimeChanged.dateTime
                ? this.currentUpdatedSetupSummary.transitingTimeChanged.dateTime
                : this.currentUpdatedSetupSummary.locationTimeChanged.dateTime);
            this.newLocationId = this.currentUpdatedSetupSummary.transitingLocationId
              ? this.currentUpdatedSetupSummary.transitingLocationId
              : this.currentUpdatedSetupSummary.locationId;

            const projectOptions = this.setupMetadata.projectOptions;
            const project = projectOptions.find(e => e.id === this.currentUpdatedSetupSummary.projectId);
            const phaseOptions = project ? project.phaseOptions : projectOptions[0].phaseOptions;
            const phase = phaseOptions.find(e => e.id === this.currentUpdatedSetupSummary.phaseId);
            const stageOptions = phase ? phase.stageOptions : phaseOptions[0].stageOptions;
            const stage = stageOptions.find(e => e.id === this.currentUpdatedSetupSummary.stageId);
            this.locationOptions = stage ? stage.locationOptions : stageOptions[0].locationOptions;

            await this.getPreviousLocation(this.currentUpdatedSetupSummary.transitingTimeChanged && this.currentUpdatedSetupSummary.transitingTimeChanged.dateTime
              ? this.currentUpdatedSetupSummary.transitingTimeChanged
              : this.currentUpdatedSetupSummary.locationTimeChanged);

            this.latestTransit = this.transitRecords[this.transitRecords.length - 1];

            // if no latestTransit, then user has removed all transitRecords, so to update the loc change record with the correct destination, we need
            // to get the latest change
            if (!this.latestTransit) {
              this.latestTransit = await this.setupService.getLocationForTime(this.instance.startTime.dateTime, true);
            }

            this.transitPreview = await this.transitService
              .createOrUpdateTransitSummary(
                this.affectedTransitHelper,
                this.instance,
                this.latestTransit.newValueId !== this.newLocationId
              );

            this.loading = false;
          });
      });
  }

  // the previous location will be the location that the vessel was last working at (using a non rig move operation)
  async getPreviousLocation(currentLocationTimeChanged: PtLuxonDate) {
    // current location -1 minute will get whatever location was active previously
    const previousLocationRecord = await this.setupService.getLocationForTime(currentLocationTimeChanged.dateTime.minus({minute: 1}));

    // if no previousLocationRecord, user is on the first day of the app and has immediately logged a transit starting at 00:00, so there is no data before this
    // we don't really care about this scenario as it can only ever happen once on the first day
    if (previousLocationRecord) {
      this.previousSetupId = previousLocationRecord.newValueId;
      this.previousLocation = previousLocationRecord.newValue;

      this.previousLocationStart = await this.dateService.setFullTimeString(previousLocationRecord.timeOfChange.dateTime);

      // previous location end should be the time of the location change record, not the transiting record
      this.previousLocationEnd = await this.dateService.setFullTimeString(this.currentUpdatedSetupSummary.locationTimeChanged.dateTime);

      // note - if the user is editing an open ended transit, then 'this.currentUpdatedSetupSummary.locationTimeChanged.dateTime' will be incorrect,
      // as the actual location time changed is null, so it has returned the one before it, we can check here if the location time changed is
      // equal to the previousLocationRecord.timeOfChange, and if it is then don't show the 'to xx:xx' part of the previous location (so previous location will
      // instead display 'Location 1 from xx:xx')
      if (this.currentUpdatedSetupSummary.locationTimeChanged.dateTime.toMillis() === previousLocationRecord.timeOfChange.dateTime.toMillis()) {
        this.hidePreviousLocationTo = true;
      } else {
        this.hidePreviousLocationTo = false;
      }
    }
  }

  async save() {
    this.loading = true;

    const validLocationChanges = this.validateLocationChanges();

    if (!validLocationChanges) {
      this.loading = false;
      return;
    }

    if (!!this.saved) {
      return;
    }

    let latestTransit = this.transitRecords[this.transitRecords.length - 1];

    // if no latestTransit, then user has removed all transitRecords, so to update the loc change record with the correct destination, we need
    // to get the latest change
    if (!latestTransit) {
      latestTransit = await this.setupService.getLocationForTime(this.instance.startTime.dateTime, true);
    }

    // this.newLocationId will be the Id for whatever location WAS the current destination on loading this page, we therefore work out if
    // the user has changed it by checking if the latestTransit has a different Id or not
    this.instance.newLocationId = latestTransit.newValueId;

    // if location is the same - don't set previousId - we use it only in helping decide what to display in the daily log setup summary
    this.instance.previousLocationId = this.instance.newLocationId !== this.currentUpdatedSetupSummary.locationId
      ? this.currentUpdatedSetupSummary.locationId
      : null;

    // todo do we need to re-add this?
    //  const deletionData = await this.createDeletionData();

    let saveRequest: OperationInstanceSaveRequest = {
      operationInstanceEditor: cloneDeep(this.instance) as DailyLogOperationInstance,
      dailyLogDate: cloneDeep(this.dailyLogDate.dateTime) as DateTime,
      newLocationId: this.newLocationId,
      transitingSetupChangeRecords: this.transitRecords
    };

    saveRequest = await this.handleVoyageLogChoice(saveRequest);

    if (!saveRequest) {
      this.loading = false;
      return;
    }

    saveRequest = await this.handleJackingActivityCreationCheck(saveRequest);

    await this.transitService.updateOrCreateTransitForSave(
      saveRequest,
      this.affectedTransitHelper,
      saveRequest.operationInstanceEditor,
      latestTransit.newValueId !== this.newLocationId);

    await this.operationSaveService.saveOperationInstance(saveRequest)
      .then(async savedInstance => {

        // todo we need to sync local app data here i think, with the updated saved operation/records data
        this.navHelperService.unsavedChanges = false;
        this.saved = true;
        this.navHelperService.warned = true;

        // todo workout if this is still needed
        // await this.appDataSyncService.deleteAppData(deletionData);

        this.presentSaveToast().then(() => {
          this.navCtrl.setRoot(DailyLogPage);
          this.navHelperService.updateNavMenuPage({page: NavMainMenuPage});
        });
      }, async error => {
        this.loading = false;
        throw (error);
      });
  }

  async handleJackingActivityCreationCheck(saveRequest: OperationInstanceSaveRequest): Promise<OperationInstanceSaveRequest> {
    if (!this.jackingDataUpdated) {
      await this.appDataSyncService.refreshJackingDataForDate(this.dailyLogDate).then(() => {
        this.jackingDataUpdated = true;
      });
    }

    if (this.jackingActivitySerivce.operationRequiresJackingActivity(saveRequest.operationInstanceEditor)) {
      if (this.dailyLogDate.dateTime.toUTC().toMillis() >= this.config.jackingV2StartDateUtc.toMillis()) {
        this.handleJackingV2Creation(saveRequest);
      } else {
        const setupRecordAtStart = await this.setupService.getLocationForTime(saveRequest.operationInstanceEditor.startTime.dateTime, false);
        const jackingActivity = await this.jackingActivitySerivce.createOrUpdateActivityForOperation(
          saveRequest.operationInstanceEditor, this.previousSetupId, setupRecordAtStart.newValueId, this.newLocationId);
        if (jackingActivity) {
          saveRequest.jackingActivityEditor = cloneDeep(jackingActivity);
        }
      }
    }

    if (this.onSiteMovementService.operationRequiresOnSiteMovementRecord(saveRequest.operationInstanceEditor)) {
      const onSiteMovementRecord = await this.onSiteMovementService.createOnSiteMovementRecordForOperation(saveRequest.operationInstanceEditor, this.newLocationId);
      if (onSiteMovementRecord) {
        saveRequest.onSiteMovementEditor = onSiteMovementRecord;
      }
    }

    return saveRequest;
  }

  private handleJackingV2Creation(saveRequest: OperationInstanceSaveRequest) {
    saveRequest.operationInstanceEditor.createJackingFormInstance = true;
    saveRequest.operationInstanceEditor.isArrivalOperation = this.jackingActivitySerivce.isArrivalJackingOperation(this.instance);
  }

  async createDeletionData(): Promise<AppDataSummary> {
    let deletionData = new AppDataSummary();

    // if we don't set ignore to true here, then if the user deletes one transit location change, any others that were added in the same batch will also be removed
    deletionData.ignoreBatchedSetupChanges = true;
    deletionData.dailyLogRecordIds = [];
    await this.operationService.localSaveProjectSpecificOperationInstance(this.instance.id, cloneDeep(this.instance));
    deletionData = this.recordOperationLinkService.checkDeletedComments(this.originalComments, this.instance.comments,
      this.instance.id, deletionData);

    const setupRecordIdsToDelete = this.setupChangeLogRecordsToDelete.map(e => e.id ? e.id : e.localId);
    const setupRecordDailyLogIdsToDelete = this.setupChangeLogRecordsToDelete.map(e => e.dailyLogRecordId ? e.dailyLogRecordId : e.localDailyLogRecordId);
    deletionData.setupChangeLogRecordIds = this.mergeIds(deletionData.setupChangeLogRecordIds, setupRecordIdsToDelete);
    deletionData.dailyLogRecordIds = this.mergeIds(deletionData.dailyLogRecordIds, setupRecordDailyLogIdsToDelete);

    return deletionData;
  }

  async addTransitingRecord() {
    const transitingRecord = await this.transitingSaveService.createBlankTransitingRecord(this.transitRecordLatestLocalId);
    this.transitRecordLatestLocalId--;
    this.transitRecords.push(transitingRecord);
  }

  async deleteTransit(transitingRecord: SetupChangeLogRecord) {
    const transitIndex = this.transitRecords.findIndex(e => transitingRecord.id
      ? e.id === transitingRecord.id
      : e.localId === transitingRecord.localId);
    this.setupChangeLogRecordsToDelete.push(this.transitRecords[transitIndex]);
    this.transitRecords.splice(transitIndex, 1);
    await this.updateTransitSummary();
  }

  async transitTimeChanged(transitingRecord: SetupChangeLogRecord) {
    const allowed = await this.dateService.timeAllowed(transitingRecord.timeOfChangeToShow,
      transitingRecord.timeOfChange && transitingRecord.timeOfChange.dateTime ? transitingRecord.timeOfChange.dateTime : this.dailyLogDate.dateTime);

    if (!allowed) {
      return;
    }

    transitingRecord.timeOfChange = await this.dateService.setPtLuxonDateFromUserEnteredString(
      transitingRecord.timeOfChangeToShow,
      transitingRecord.timeOfChange && transitingRecord.timeOfChange.dateTime
        ? transitingRecord.timeOfChange.dateTime
        : this.dailyLogDate.dateTime);
    transitingRecord.timeOfChangeOffset = transitingRecord.timeOfChange.dateTime.offset / 60;

    // if user has input a location on the record already, then call this method which will sort the records in order by time
    // if they haven't input the location - then just do nothing as this will be called anyway when they select the location
    if (transitingRecord.newValueId) {
      await this.updateTransitSummary();
    }
  }

  async transitLocationChanged(newValueId: number, transitingRecord: SetupChangeLogRecord) {
    transitingRecord.selectedLocation = this.locationOptions.find(e => e.id == newValueId);
    transitingRecord.newValueId = newValueId;
    transitingRecord.newValue = this.locationOptions.find(e => e.id === newValueId).name;

    await this.updateTransitSummary();
  }

  async updateTransitSummary() {
    this.affectedTransitHelper = await this.transitService.getAffectedTransits(this.instance.startTime, this.instance.endTime, this.instance.id);

    this.transitRecords = this.transitRecords.sort((function (a, b) {
      if (!a.timeOfChange || !a.timeOfChange.dateTime || !b.timeOfChange || !b.timeOfChange.dateTime) {
        return 0;
      }

      return a.timeOfChange.dateTime.toMillis() - b.timeOfChange.dateTime.toMillis();
    }));

    let latestTransit = this.transitRecords[this.transitRecords.length - 1];

    // if no latestTransit, then user has removed all transitRecords, so to update the loc change record with the correct destination, we need
    // to get the latest change
    if (!latestTransit) {
      latestTransit = await this.setupService.getLocationForTime(this.instance.startTime.dateTime, true);
    }

    this.transitPreview = await this.transitService
      .createOrUpdateTransitSummary(
        this.affectedTransitHelper,
        this.instance,
        !this.affectedTransitHelper.transitAfterOperation && latestTransit.newValueId !== (this.currentUpdatedSetupSummary.transitingLocationId
        ? this.currentUpdatedSetupSummary.transitingLocationId
        : this.currentUpdatedSetupSummary.locationId));
  }

  async handleVoyageLogChoice(saveRequest: OperationInstanceSaveRequest): Promise<OperationInstanceSaveRequest> {
    this.voyageLogValidationResult = new ValidationResult();

    // handling voyage log choice
    if (this.voyageLogCreateId === 1 && !this.startLinkedVoyageLog) {
      const creationValidation = await this.voyageLogService.validateVoyageCreation(
        this.instance.startTime.dateTime);

      if (!creationValidation.canCreate) {
        this.voyageLogValidationResult.addError(
          creationValidation.reason,
          ErrorType.Default
        );
        return null;
      }

      // need to get the latest location instead of using 'this.setupSummary.locationId' - as if the current operation is already
      // mid-transit - then the setup summary will be the transiting to record not the actual location record
      const latestLocation = await this.setupService.getSetupLocationForTime(
        saveRequest.operationInstanceEditor.startTime,
        this.currentUpdatedSetupSummary.transitingLocationId);
      saveRequest.voyageLog = this.voyageLogService.createVoyageLogSummary(
        saveRequest.operationInstanceEditor,
        latestLocation.newValueId,
        this.precedingVoyageLog);
      saveRequest.voyageLog.voyageNumber = creationValidation.proposedVoyageNumber;
    } else if (this.voyageLogEndId === 1) {
      // voyage being ended
      saveRequest.voyageLog = this.endLinkedVoyageLog || this.voyageLogForOperationTime;

      if (!saveRequest.voyageLog) {
        this.voyageLogValidationResult.addError(
          'No linked or active voyage was found at this operation time, so this operation cannot end a voyage.',
          ErrorType.Default
        );
        return null;
      }

      saveRequest.voyageLog.distance = Number(this.voyageDistance);

      if (saveRequest.operationInstanceEditor.endTime) {
        saveRequest.voyageLog.endDate = saveRequest.operationInstanceEditor.endTime.dateTime;
      }

      saveRequest.voyageLog.endLocationId = this.currentUpdatedSetupSummary.transitingLocationId
        ? this.currentUpdatedSetupSummary.transitingLocationId
        : this.currentUpdatedSetupSummary.locationId;
      saveRequest.voyageLog.endOperationId = saveRequest.operationInstanceEditor.id ? saveRequest.operationInstanceEditor.id : saveRequest.operationInstanceEditor.localId;
    } else if (this.showVoyageCreationOption && this.startLinkedVoyageLog && this.voyageLogCreateId === 2) {
      // voyage start being removed
      saveRequest.voyageLogRemoved = true;
      saveRequest.voyageLog = this.startLinkedVoyageLog;
    } else if (this.showVoyageEndOption && this.endLinkedVoyageLog && this.voyageLogEndId === 2) {
      // voyage end being removed
      saveRequest.voyageLogEndRemoved = true;
      saveRequest.voyageLog = this.endLinkedVoyageLog;
    }

    return saveRequest;
  }

  // updates location change record with location info based on current newLocation, and attaches the daily log record to current operation
  async updateLocationChangeSetupAndDailyLogRecord(
    locationChangeSetupRecord: SetupChangeLogRecord,
    latestTransit: SetupChangeLogRecord
  ): Promise<DailyOperationLogRecordHelper> {
    const helper = new DailyOperationLogRecordHelper();
    const locationChangeDailyLogRecord = locationChangeSetupRecord
      ? await this.dailyLogService.getDailyLogRecordDirect(locationChangeSetupRecord.dailyLogRecordId)
      : null;
    helper.records = [];
    helper.setupChangeLogRecords = [];

    if (locationChangeDailyLogRecord) {
      let operationName = 'To ' + this.locationOptions.find(e => e.id === latestTransit.newValueId).name;

      if (locationChangeSetupRecord.previousValue !== null) {
        operationName = 'From ' + locationChangeSetupRecord.previousValue + ' ' + operationName;
      }

      locationChangeDailyLogRecord.operationName = operationName;
      locationChangeDailyLogRecord.operationInstanceId = this.instance.id;
      locationChangeDailyLogRecord.operationInstanceLocalId = this.instance.localId;
      locationChangeDailyLogRecord.startTimeOffset = cloneDeep(this.instance.endTimeOffset);
      locationChangeDailyLogRecord.startTime = cloneDeep(this.instance.endTime);
      locationChangeDailyLogRecord.startTimeShow = this.instance.endTimeToShow;
      // although .sortTime is local around the app, because we added the local offset to this.instance earlier in the save method, this.instance.endTime.date
      // is the correct date to use here, not the local date
      locationChangeDailyLogRecord.sortTime = cloneDeep(this.instance.endTime.dateTime);

      helper.records.push(locationChangeDailyLogRecord);
    }

    if (locationChangeSetupRecord) {
      locationChangeSetupRecord.newValue = this.locationOptions.find(e => e.id === latestTransit.newValueId).name;
      locationChangeSetupRecord.newValueId = latestTransit.newValueId;
      locationChangeSetupRecord.timeOfChange = cloneDeep(this.instance.endTime);
      locationChangeSetupRecord.timeOfChangeOffset = this.instance.endTime && this.instance.endTime.dateTime
        ? cloneDeep(this.instance.endTime.dateTime.offset / 60)
        : null;
      locationChangeSetupRecord.timeOfChangeToShow = this.instance.endTimeToShow;

      helper.setupChangeLogRecords.push(locationChangeSetupRecord);
    }

    return helper;
  }

  async getPreviousTransitToInTransit(): Promise<SetupChangeLogRecord> {
    const previousTransit = await this.setupService.getLocationForTime(this.instance.startTime.dateTime, true);

    return previousTransit;
  }

  // gets the previous location change record, if in the same 'transit' that the user is currently making
  async getPreviousLocationInTransit(latestTransit: SetupChangeLogRecord): Promise<SetupChangeLogRecord> {
    const previousLocation = await this.setupService.getLocationForTime(this.instance.startTime.dateTime);
    if (previousLocation == null || latestTransit.newValueId !== previousLocation.newValueId) {
      return null;
    }

    return previousLocation;
  }

  presentSaveToast(): Promise<any> {
    const toast = this.toastCtrl.create({
      message:
        `${this.instance.isConcurrentOperation ? 'Concurrent ' : 'Contractual '}`
        + 'Operation \''
        + `${this.instance.projectSpecificOperation.name
        ? this.instance.projectSpecificOperation.name
        : this.instance.projectSpecificOperation.operationSummary.name}`
        + '\' updated successfully',
      duration: 6000,
      position: 'bottom'
    });

    return toast.present();
  }

  validateLocationChanges(): boolean {
    this.locationChangeValidationResult = new ValidationResult();
    let showDuplicateLocationChangeMessage = false;

    for (let i = 0; i < this.transitRecords.length; i++) {
      if (!this.transitRecords[i].newValueId) {
        this.locationChangeValidationResult.addError(`Location Changes must have a location selected.`, ErrorType.Default);
      }

      if (!this.transitRecords[i].timeOfChange || !this.transitRecords[i].timeOfChange.dateTime) {
        this.locationChangeValidationResult.addError(`Location Changes must have a valid time.`, ErrorType.Default);
        continue;
      }

      if ((this.transitRecords[i].timeOfChange.dateTime < this.instance.startTime.dateTime
        || (this.instance.endTime && this.instance.endTime.dateTime
          ? this.transitRecords[i].timeOfChange.dateTime > this.instance.endTime.dateTime
          : this.transitRecords[i].timeOfChange.dateTime > this.endOfDay.dateTime))) {
        this.locationChangeValidationResult.addError(`Location Change times must fall within the Operation Start and End times.`, ErrorType.Default);
      }

      for (let j = 0; j < this.transitRecords.length; j++) {
        const differentRecord = this.transitRecords[i].id
          ? this.transitRecords[i].id !== this.transitRecords[j].id
          : this.transitRecords[i].localId !== this.transitRecords[j].localId;

        if (!showDuplicateLocationChangeMessage && differentRecord
          && this.transitRecords[i].timeOfChange
          && this.transitRecords[j].timeOfChange
          && this.transitRecords[i].timeOfChange.dateTime.toMillis() === this.transitRecords[j].timeOfChange.dateTime.toMillis()) {
          this.locationChangeValidationResult.addError(`Location Changes must not have the same time as another change.`, ErrorType.Default);
          showDuplicateLocationChangeMessage = true;
          break;
        }
      }
    }

    if (this.locationChangeValidationResult.errors && this.locationChangeValidationResult.errors.length > 0) {
      this.locationChangeValidationResult.isValid = false;
      return false;
    }

    return true;
  }

  // can merge any objects that contain an id or localId value
  // merges existing array with new array based on values from id and localId, while removing duplicates (found duplicates will take the value from newArray)
  mergeRecords(existingArray, newArray): any[] {
    const existingArrayCopy = cloneDeep(existingArray);
    const newArrayCopy = cloneDeep(newArray);

    for (let i = 0; i < newArrayCopy.length; i++) {
      const index = existingArrayCopy.findIndex(existingItem => newArrayCopy[i] && newArrayCopy[i].id
        ? existingItem.id === newArrayCopy[i].id
        : newArrayCopy[i] && newArrayCopy[i].localId
          ? existingItem.localId === newArrayCopy[i].localId
          : -1);

      if (index !== -1) {
        existingArrayCopy[index] = newArrayCopy[i];
      } else if (newArrayCopy[i]) { // prevents pushing undefined items - needed because newArray[i] can be undefined if user deletes newly added changes
        existingArrayCopy.push(newArrayCopy[i]);
      }
    }

    return existingArrayCopy;
  }

  mergeIds(existingArray: number[], newArray: number[]) {
    const existingArrayCopy = cloneDeep(existingArray);
    const newArrayCopy = cloneDeep(newArray);

    for (let i = 0; i < newArrayCopy.length; i++) {
      const index = existingArrayCopy.findIndex(existingItem => newArrayCopy[i]
        ? existingItem === newArrayCopy[i]
        : -1);

      if (index !== -1) {
        existingArrayCopy[index] = newArrayCopy[i];
      } else if (newArrayCopy[i]) { // prevents pushing undefined items - needed because newArray[i] can be undefined if user deletes newly added changes
        existingArrayCopy.push(newArrayCopy[i]);
      }
    }

    return existingArrayCopy;
  }

  regexChange(inputTime: string) {
    if (inputTime.charAt(0) === '2') {
      this.mask[1] = new RegExp('[0-3]');
    } else {
      this.mask[1] = new RegExp('\\d');
    }
  }

  async offsetSelected(ptLuxonDate: PtLuxonDate, transit: SetupChangeLogRecord) {
    transit.timeOfChangeOffset = ptLuxonDate.dateTime.offset / 60;
  }

  async createLocationChangeSetupAndDailyLogEntries(
    localDailyLogRecordId: number,
    uniqueOrdinal: number,
    localSetupChangeRecordId: number,
    latestTransit: SetupChangeLogRecord,
  ): Promise<DailyOperationLogRecordHelper> {
    const helper = new DailyOperationLogRecordHelper();
    helper.records = [];
    helper.setupChangeLogRecords = [];

    const locationChangeSetupRecord: SetupChangeLogRecord = {
      id: null,
      localId: localSetupChangeRecordId,
      changeType: SetupChangeType.LocationChange,
      changeTypeId: SetupChangeType.LocationChange,
      previousValue: this.currentUpdatedSetupSummary.locationName,
      previousValueId: this.currentUpdatedSetupSummary.locationId,
      newValue: this.locationOptions.find(e => e.id === latestTransit.newValueId).name,
      newValueId: latestTransit.newValueId,
      timeOfChange: cloneDeep(this.instance.endTime),
      timeOfChangeToShow: this.instance.endTimeToShow,
      timeOfChangeOffset: this.instance.endTime.dateTime.offset / 60,
      dailyLogRecordId: null,
      localDailyLogRecordId: null,
      batchId: null,
    };

    const locationChangeEditor: LocationChangeEditor = {
      classification: 'Location',
      previousName: this.currentUpdatedSetupSummary ? this.currentUpdatedSetupSummary.locationName : 'No Location',
      newName: this.locationOptions.find(e => e.id === latestTransit.newValueId).name,
      id: localDailyLogRecordId,
      uniqueOrdinal: uniqueOrdinal,
      type: DailyLogType.LocationChange,
      operationInstance: cloneDeep(this.instance)
    };

    const locationChangeHelper = await this.dailyLogEntryService.createLocationChangeLogEntry(locationChangeEditor, latestTransit.newValueId, true);

    // think all records get saved locally at the end - so not needed any more
    // this.setupService.saveSetupChangeLogRecord(locationSetupId, locationChangeSetupRecord);

    locationChangeSetupRecord.localDailyLogRecordId = locationChangeHelper.records[0].localId;
    helper.records.push(locationChangeHelper.records[0]);
    helper.setupChangeLogRecords.push(locationChangeSetupRecord);


    // dont think this is needed anymore, keeping for now
    // if (!location || this.instance.endTime.dateTime < new Date()
    //   && this.instance.endTime.dateTime > locationChangeSetupRecord.timeOfChange.getDate()) {
    //   this.setupService.saveSetup(setupSummary);
    // }

    return helper;
  }

  private setSupportContext() {
    this.supportContextService.setComponentContext(
      SupportContextKey.EditOperation,
      'Edit Operation',
      'OperationDetailsEditLocationSelectPage',
      {
        view: 'Location Select',
        instanceId: this.getOperationInstanceId(),
        operationName: this.getOperationName()
      }
    );
  }

  private getOperationInstanceId(): string {
    if (!this.instance) {
      return '';
    }

    return this.instance.id != null
      ? `${this.instance.id}`
      : this.instance.localId != null
        ? `${this.instance.localId}`
        : '';
  }

  private getOperationName(): string {
    if (!this.instance || !this.instance.projectSpecificOperation) {
      return '';
    }

    return this.instance.projectSpecificOperation.name
      || this.instance.projectSpecificOperation.operationSummary?.name
      || '';
  }
}



// WEBPACK FOOTER //
// ./src/pages/operations/operation-details-edit-location-select/operation-details-edit-location-select.ts